var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipe12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 240,
    viewBox: "0 0 45 240",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 -9.11957e-06L45 240L1.52588e-05 240L-2.86134e-06 1.5042e-05L45 -9.11957e-06Z",
    fill: "#AFCAE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 78.1893L3.01196 61.3921L41.9511 61.3921L22.4815 78.1893Z",
    fill: "url(#paint0_linear_13_79)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 64.7928L3.03051 47.9956L41.9696 47.9956L22.5001 64.7928Z",
    fill: "url(#paint1_linear_13_79)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5186 51.3969L3.04907 34.5996L41.9882 34.5996L22.5186 51.3969Z",
    fill: "url(#paint2_linear_13_79)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_79",
    x1: 22.4815,
    y1: 78.1893,
    x2: 22.4815,
    y2: 55.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_79",
    x1: 22.5001,
    y1: 64.7928,
    x2: 22.5001,
    y2: 42.3965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_79",
    x1: 22.5186,
    y1: 51.3969,
    x2: 22.5186,
    y2: 29.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe12);
export default __webpack_public_path__ + "static/media/pipe-12.69fb24ee9c665698f4d29c647e919536.svg";
export { ForwardRef as ReactComponent };